import { ExternalLinkIcon, FilterIcon, X } from "lucide-react";
import { Button } from "web-design-system";
import { useLocalStorage } from "usehooks-ts";

// Stays dismissed on this browser once closed; shared so the Sunrise smart
// view can dismiss it too
export function useSunriseBannerDismissed() {
  return useLocalStorage("sunrise-funds-banner-dismissed", false);
}

const SUNRISE_FUNDS_ARTICLE_URL =
  "https://creso.in/blog/sunrise-mutual-funds-india";

export function SunriseFundsBanner({ onFilter }: { onFilter: () => void }) {
  const [dismissed, setDismissed] = useSunriseBannerDismissed();

  if (dismissed) return null;

  return (
    <div className="flex flex-row items-center gap-4 rounded-lg border border-border bg-linear-to-r from-white to-orange-50 px-5 py-4">
      {/* TODO: replace with the Sunrise icon once it's available */}
      <img
        className="size-12 shrink-0"
        src="/assets/images/ranks/sunrise.webp"
        alt="Sunrise funds"
      />
      <div className="flex flex-col gap-1 flex-1 min-w-0">
        <span className="text-sm font-semibold">Introducing Sunrise Funds</span>
        <div className="flex flex-row items-center gap-1">
          <span className="text-sm">
            Check out our shortlist of upcoming funds that have a bright future
            outlook.
          </span>
          <a
            href={SUNRISE_FUNDS_ARTICLE_URL}
            target="_blank"
            className="inline-flex items-center gap-1 align-middle text-sm"
            rel="noreferrer"
          >
            Learn more
            <ExternalLinkIcon className="size-4" />
          </a>
        </div>
      </div>
      <Button
        variant="outline"
        className="shrink-0"
        onClick={() => {
          setDismissed(true);
          onFilter();
        }}
      >
        <FilterIcon className="size-4" />
        Filter
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="shrink-0"
        aria-label="Dismiss"
        onClick={() => setDismissed(true)}
      >
        <X className="size-4" />
      </Button>
    </div>
  );
}
